import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { ICompanyInfo } from 'core/interface/matchProfile';

const initialValues: ICompanyInfo = {
  location: {
    id: 0,
    display_name: ''
  },
  contact_job_title: ''
};

const validationSchema = (t: TFunction) => {
  return Yup.object({
    location: Yup.object({
      id: Yup.number().required(t('required')),
      display_name: Yup.string().required(t('required'))
    }).required(t('required')),
    contact_job_title: Yup.string().required(t('required'))
  });
};

export { validationSchema, initialValues };
